import {ItemSearch} from './ItemSearch';

export class SparePartBookSearch extends ItemSearch {

  private bookLinkSelector: string;
  private bookFrameId: string;

  constructor(selector: string, ajaxEndpoint: string, resultTemplateSelector: string, resultContainerSelector: string){

    super(selector, ajaxEndpoint, resultTemplateSelector, resultContainerSelector);

    this.bookFrameId = 'js-sparepart-book__iframe';
    this.bookLinkSelector = '.js-sparepart-manual-link';
  }

  /**
  * Process search results and add markup to the result element - extend parent class method
  * @param {object} data - data to be rendered in the template
  */
  public processSearchResults(data:any) {
    if(data?.books){
      super.processSearchResults(data);
      this.openSparePartBook();
    }
  }


  /*
  * Handles search result PDF links and adds click eveent
  *
  **/
  public openSparePartBook() {

    //clear iframe content before adding new book
    (<HTMLIFrameElement>document.getElementById(this.bookFrameId)).src= '';

    const bookLinks = document.querySelectorAll(this.bookLinkSelector);

    bookLinks.forEach(link => (
      link.addEventListener('click', ()=> this.openIframe(link) )
    ));

  }

  /*
  * opens PDF to iframe
  * @param {Element} link - clicked link element. containts data-attribute with PDF url
  */
  public openIframe(link : Element) {

    const bookUrl = link.getAttribute('data-manual');

    if(bookUrl){
      if (window.innerWidth < 1024) {
        window.open(bookUrl, '_blank').focus();
      } else {
        (<HTMLIFrameElement>document.getElementById(this.bookFrameId)).src = bookUrl; //set iframe src
        (<HTMLIFrameElement>document.getElementById(this.bookFrameId)).innerHTML = `<p>Oops! Your browser doesn't support PDFs!</p>
        <p><a href="${bookUrl}" target="_blank">Download Instead</a></p>`
        this.resultContainer.textContent = '';
      }
    }

  }

}
